import React from "react";
import {Select, Tag, Typography} from "antd"

const {Text} = Typography

export default class CheckboxDataField extends React.Component {
    render() {

        const {edit, propertie, value, onChange} = this.props


        if (!edit) {
            if (value === true) {
                return <Tag color={"green"}>Oui</Tag>
            }
            if (value === false) {
                return <Tag color={"red"}>Non</Tag>
            }
        }


        return (
            <Select
                defaultValue={value}
                onChange={(v) => {
                    onChange(v)
                }}
            >
                <Select.Option value={true}><Tag color={"green"}>Oui</Tag></Select.Option>
                <Select.Option value={false}><Tag color={"red"}>Non</Tag></Select.Option>
            </Select>
        )
    }
}
